import { LocalTime } from '@js-joda/core';

import { BindingCreator } from '@dreryk/react-common';
import { StyledMaxWidth, TimePicker } from '@dreryk/react-components';

import { patientMedicalInformationTranslationKeys } from '../../../translations';

const t = patientMedicalInformationTranslationKeys.medicalImaging.form;

const EXAMINATION_DATE_FIELD_NAME = 'examinationTime';

type ExaminationTimeType = LocalTime;

export type ExaminationTimeFormBeanPart = { [EXAMINATION_DATE_FIELD_NAME]: ExaminationTimeType };

type ExaminationTimePickerProps = { readonly register: BindingCreator<ExaminationTimeFormBeanPart> };

export const ExaminationTimePicker = (props: ExaminationTimePickerProps): JSX.Element => {
   return (
      <StyledMaxWidth maxWidth={136}>
         <TimePicker
            testId={EXAMINATION_DATE_FIELD_NAME}
            controller={props.register(EXAMINATION_DATE_FIELD_NAME, { required: true })}
            label={t.examinationTime.label}
         />
      </StyledMaxWidth>
   );
};
